<div class="file-uploader-section" >
    <div [hidden]="isClientManager">
        <div *ngIf="showTemplate">
            <div>
                <div class="step-number-section">
                    <div class="step-number-circle"><span class="step-number">1</span></div>
                </div>
                <div *ngIf="uploadedFileType!=this.fileTypeEnum.BusinessComponent" class="template-guide-section1"
                    (click)="download()">
                    Please use the template to import data in the required format.
                </div>
                <div *ngIf="uploadedFileType===this.fileTypeEnum.BusinessComponent">
                    <div class="template-guide-section1" (click)="download()">
                        Use the template to ensure accurate data synchronization by completing all required fields.
                        <div class="bc-info-section">Business Component</div>
                        <div>
                            <ul>
                                <li><small>You can add business components later if needed.</small></li>
                                <li><small>If included, their qualified percentages must be provided and will replace
                                        existing data. </small></li>
                            </ul>
                        </div>
                        <!-- To ensure accurate data synchronization,please use the template and complete all
                        required fields.If you do not have any business component at the moment, you can manually
                        create them later in the process. -->
                    </div>
                </div>
            </div>

            <div>
                <div class="payroll-template-button-section">
                    <button type='button' *ngIf="uploadedFileType===this.fileTypeEnum.Employee"
                        class="btn btn-secondary survey-button blue-button"
                        (click)="download('Employee_Template.xlsx')">
                        <i class="fas fa-file-excel"></i> Employee
                        Template
                    </button>
                    <button type='button' *ngIf="uploadedFileType===this.fileTypeEnum.Project"
                        class="btn btn-secondary survey-button blue-button" (click)="download('Project_Template.xlsx')">
                        <i class="fas fa-file-excel"></i> Project
                        Template
                    </button>
                    <button type='button' *ngIf="uploadedFileType===this.fileTypeEnum.TimeTracking"
                        class="btn btn-secondary survey-button blue-button" (click)="download('TimeTracking.xlsx')">
                        <i class="fas fa-file-excel"></i> Time Tracking
                        Template
                    </button>
                    <button type='button' *ngIf="uploadedFileType===this.fileTypeEnum.ClientUser"
                        class="btn btn-secondary survey-button blue-button mr-3"
                        (click)="download('User_Template.xlsx')">
                        <i class="fas fa-file-excel">&nbsp;</i> User Template
                    </button>
                    <button type='button' *ngIf="uploadedFileType===this.fileTypeEnum.BusinessComponent"
                        class="btn btn-secondary survey-button blue-button mr-3"
                        (click)="download('BusinessComponent_Template.xlsx')">
                        <i class="fas fa-file-excel">&nbsp;</i> Business Component Template
                    </button>
                </div>
            </div>
        <div [hidden]="!importFromRCN">
            <div class="template-guide-section2">
                <div class="step-number-section">
                    <div class="step-number-circle"><span class="step-number">2</span></div>
                </div>

                <div *ngIf="uploadedFileType!=this.fileTypeEnum.BusinessComponent" class="template-guide-section1">
                    You can import the file after filling the template with data.
                    <!-- <div> The upload process may take up to 1-2 minutes.</div> -->
                </div>
                <div *ngIf="uploadedFileType===this.fileTypeEnum.BusinessComponent" class="template-guide-section1">
                    Once you have completed the template upload it here.
                </div>
            </div>
            <br>
            <div class="template-guide-section2" *ngIf="uploadedFileType===this.fileTypeEnum.ClientUser">
                <div class="step-number-section">
                    <div class="step-number-circle"><span class="step-number">3</span></div>
                </div>

                <div class="template-guide-section1">
                    If you are copying and pasting employee information from an excel file
                    please 'paste as values' to remove any formatting from the source file.
                    <!-- <div> The upload process may take up to 1-2 minutes.</div> -->
                </div>
            </div>
            <div class="template-guide-section2">

                <div *ngIf="uploadedFileType===this.fileTypeEnum.Employee" class="template-guide-section1">
                    Note: Limit the number of employees in this import to 5000. Also note that import may take a few
                    seconds
                    to a few minutes <br>depending on the number of employees.
                </div>
                <div *ngIf="uploadedFileType===this.fileTypeEnum.Project" class="template-guide-section1">
                    Note: Limit the number of projects in this import to 250. Also note that import may take a few
                    seconds
                    to a few minutes <br>depending on the number of records.
                </div>
                <div *ngIf="uploadedFileType===this.fileTypeEnum.TimeTracking" class="template-guide-section1">
                    Note: Limit the number of records in this import to 5000.<br> Also note that import may take a few
                    seconds
                    to a few minutes <br>depending on the number of records.<br><br>
                    WARNING: When uploading time tracking, if you have an employee on a previous import it will override
                    ALL of the employee records to the most recent file.
                </div>

            </div>
        </div>
        </div>
        <div [hidden]="!importFromRCN">
        <div *ngIf="surveyCategory === 0 || uploadedFileType === this.fileTypeEnum.ExpenseSurvey">
            <ng-multiselect-dropdown [placeholder]="'Tag Business Components'" [settings]="dropdownSettings" [data]="dropdownList"
                [(ngModel)]="selectedTagProjectList" [ngModelOptions]="{standalone: true}"
                (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)" class="full-width">
            </ng-multiselect-dropdown>
            <div class="right-tag-icon">
                <div class="tag-icon">
                    <i class="fas fa-tag s-icon-size"></i>
                </div>
            </div>
        </div>
        <div>
            <span *ngIf="uploadedFileType===this.fileTypeEnum.SurveyCompleteInstructions">Study specific instructions
                file must be PDF or Excel (xlsx).</span>
            <p
                *ngIf="uploadedFileType!==this.fileTypeEnum.Employee && uploadedFileType!==this.fileTypeEnum.Project && uploadedFileType!==this.fileTypeEnum.ExpenseData && uploadedFileType!==this.fileTypeEnum.TimeTracking && uploadedFileType!=this.fileTypeEnum.BusinessComponent">
                The import process may take up to 2 minutes. <span
                    *ngIf="uploadedFileType === fileTypeEnum.ExpenseSurvey"><br /> You can see some examples of
                    contemporaneous documents <a (click)="openContemporaneousDocInfo()">here</a></span>
            </p>
            <div *ngIf="uploadedFileType===this.fileTypeEnum.ExpenseData">
                Prior to the import, please check for negative expense amounts and consider consolidating the expenses.
                The import process may take a few seconds to minutes depending on the size of the file.
            </div>
        </div>
        <div *ngIf="uploadedFileType===this.fileTypeEnum.ExpenseData" class="uploader-process-text">
            If your study spans multiple tax periods, include a column titled 'Tax Period'.
        </div>
        <div *ngIf="uploadedFileType===this.fileTypeEnum.ExpenseData" class="uploader-process-text">
            Note: Limit the number of records in this import to 25,000.
        </div>
        </div>
    </div>
    <div *ngIf="isClientManager">
        <div>
            <div>
                Not sure what to upload? Check out the
                <a (click)="openContemporaneousDocInfo()">
                    <b>Documentation Guide</b>
                </a>
            </div>
            <br />
            <div>
                <ng-multiselect-dropdown [placeholder]="'Tag Business Components'" [settings]="dropdownSettings"
                    [data]="dropdownList" [(ngModel)]="selectedTagProjectList" [ngModelOptions]="{standalone: true}"
                    (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)" class="full-width">
                </ng-multiselect-dropdown>
                <div class="right-tag-icon-project">
                    <div class="tag-icon">
                        <i class="fas fa-tag s-icon-size"></i>
                    </div>
                </div>
            </div>
            <br />
        </div>
    </div>
<div [hidden]="!importFromRCN">
    <div class="uploader-box-container">
        <div class="file-uploader uploader-style">
            <input #fileUploader type="file" class="form-control-file" (click)="fileUploader.value = null"
                [accept]="allowedFileType" (change)="onFileUpload()" />
        </div>
    </div>
    <div class="file-upload-details-section" *ngIf="uploadedFile">
        <div class="file-upload-name-section">
            {{uploadedFile.name}}
        </div>
        <div *ngIf="showprogressbar" class="progress-bardiv">
            <progress id="progressBar" [value]="progress" max="100" class="progress-bar"></progress>
            <span>{{progress}}%</span>
            <span *ngIf="uploadFailed" title="Unable to upload. Please try again.">
                <i class="fas fa-exclamation-triangle upload-failed"></i>
            </span>
        </div>
        <div class="file-upload-delete-section">
            <i class="fas fa-trash rcn-coloring delete-file" (click)="deleteFile()"></i>
        </div>
    </div>
    <br />
    <div class="upload-description-section">
        <label for="Description">
            <textarea placeholder="Enter description here (optional)" [(ngModel)]='uploadDescription' size="5" rows="4"
                cols="73" no-special-chars="#!$%^<>+='" name="Description" class="description-text-section"
                maxlength="3000" *ngIf="isClientManager">
        </textarea>
        </label>
    </div>
    </div>
</div>


<div *ngIf="false">
    <survey-document [uploaderTitle]="uploaderTitle" [surveyDocuments]="uploadedDocuments"
        (documentEvent)="onDocumentEvent($event)">
    </survey-document>
</div>
<div
    *ngIf="uploadedFileType === fileTypeEnum.Employee || uploadedFileType === fileTypeEnum.Project || uploadedFileType === fileTypeEnum.ClientUser || uploadedFileType === fileTypeEnum.BusinessComponent">
    <div *ngIf="showFileImportSection" class="file-uploader-section">
        <div class="template-guide-section2">
            <div class="step-number-section" >
                <div class="step-number-circle">
                    <span
                        *ngIf="uploadedFileType === fileTypeEnum.Employee || uploadedFileType === fileTypeEnum.Project || uploadedFileType === fileTypeEnum.BusinessComponent"
                        class="step-number">{{ importFromRCN ? 3 : 2 }}</span>
                    <span *ngIf="uploadedFileType === fileTypeEnum.ClientUser" class="step-number">{{ importFromRCN ? 4 : 3 }}</span>
                </div>
            </div>

            <div class="template-guide-section1" >
                File Import History
            </div>
        </div>
    </div>
    <uploaded-file-list (showFileImportSection)="updateShowFileImportSection($event)" [fileType]="uploadedFileType"
        [engagementId]="study.engagementId"></uploaded-file-list>
</div>
<div class="file-uploader-button-section" >
    <div class="">
        <ng-container *ngIf="importFromRCN">
            <button *ngIf="!isClientManager" type='button' class="btn btn-success"
                [disabled]="!fileUploader.value || !isValidFile || isUploadDisabled" (click)="uploadFile()">
                Import
            </button>
            <button *ngIf="isClientManager" type='button' class="btn btn-success"
                [disabled]="!fileUploader.value || !isValidFile || isUploadDisabled" (click)="uploadFile()">
                Upload
            </button>
        </ng-container>
        &nbsp;<button class="btn kpmg-button--flat" (click)="closeFileUploader(true)">
            Cancel
        </button>
    </div>
</div>

<confrimation-box [title]="isClientManager?'Upload Confirmation':'Import Confirmation'" [message]='confirmModalContent'
    (confirmBoxHandler)="confirm($event)" [projectCSS]='true' *ngIf="showConfirmationBox"></confrimation-box>

<rcn-bc-upload-confirm-dialog *ngIf="showBCUploadConfirmDialog" (proceedImport)="importBCUpload()"
    (closeConfirmDialog)="cancelBCUpload()">
</rcn-bc-upload-confirm-dialog>
